/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface OctopusPremiumComponentArgs {
  targetPathId: string;
  containerWidth: number;
}

function isSVGGeometryElement(element: any): element is SVGGeometryElement {
  return element.pathLength != null;
}

export default class OctopusPremiumComponent extends Component<OctopusPremiumComponentArgs> {
  @tracked premiumTagElement: HTMLDivElement | null = null;
  @action
  didInsertPremiumTagElement(premiumTagElement: HTMLDivElement) {
    this.premiumTagElement = premiumTagElement;
    this.positionPremiumTagElement();
  }

  @action
  positionPremiumTagElement() {
    let { premiumTagElement } = this;
    let targetElement = document.querySelector(`#${this.args.targetPathId}`);

    if (!isSVGGeometryElement(targetElement) || !premiumTagElement) {
      return;
    }

    let pathLength = targetElement.getTotalLength();

    // How far from the end of the path the Premium tag should be
    // positioned, in pixels.
    // Arbitrary value set by eye, based on various screen sizes
    // and quantity of items.
    let offset = 70;

    let coords = targetElement.getPointAtLength(pathLength - offset);
    let dimensions = premiumTagElement.getBoundingClientRect();
    premiumTagElement.style.left = `${Math.round(coords.x - dimensions.width / 2)}px`;
    premiumTagElement.style.top = `${Math.round(coords.y - dimensions.height / 2)}px`;
  }
}
